<script lang="ts">
    import type {Optional} from "../../../types/squirrel";
    import {SqrlTestId} from "../../../constants/squirrel";

    interface Props {
        img: Optional<string>;
        alt: string;
    }

    let {img, alt}: Props = $props();

</script>
{#if img != null}
    <div class="squirrel_img"
         data-testid={SqrlTestId.LIST_IMG}>
        <img class="squirrel_img__image"
             src={img+"/?w=128&h=128&upscale=true&fmt=webp&"}
             alt={alt}/>
    </div>
{/if}

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .squirrel_img {
    display: flex;
    color: tokens.$oc-base-color-black-100;
    cursor: pointer;
    width: min-content;
    height: max-content;
    padding: tokens.$oc-semantic-spacing-relative-25 tokens.$oc-semantic-spacing-relative-50;

    &__image {
      height: 40px;
      border-radius: 8px;
    }
  }
</style>